import { ScaleLoader } from 'react-spinners';
import { PrimaryColor } from '../../../utils/constants/style';
import { useContext } from 'react';
import { ThemeContext } from '../../../utils/providers/theme-context';

interface Props {
  height?: number;
  width?: number;
  color?: string;
}

export default function Loader(props: Props) {
  const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error('Loader must be used within a ThemeProvider');
  }

  const { brandColor } = themeContext;

  return (
    <ScaleLoader
      height={props.height ?? 20}
      width={props.width ?? 4}
      radius={4}
      color={props.color ?? brandColor ?? PrimaryColor}
      loading
    />
  );
}
